import * as PIXI from 'pixi.js'
import { getImageAssetPath, IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT } from '@aytm/lib/common/assets'

// export const CANVAS_RESIZE_FACTOR = 2
export const FIRST_LAYER_COLOR = 0xffffff
export const SECOND_LAYER_COLOR = 0x555555
export const THIRD_LAYER_COLOR = 0xaaaaaa
export const HIDDEN_COLOR = 0xbbbbbb

export function getProductImage(answer) {
  return answer.getIn(['picture', 'original_path'])
    ? getImageAssetPath({
        filter: IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT,
        width: 600,
        height: 1600,
        path: answer.getIn(['picture', 'original_path']),
        backgroundColor: 'transparent',
        animated: true,
        trim: true
      })
    : '/images/widget/sh/emptyBottle.png'
}

export function drawEmptyProduct(settings) {
  const baseTexture = new PIXI.Texture.from('/images/widget/sh/empty.png')
  const cat = PIXI.Sprite.from(baseTexture, {
    mipmap: false,
    scaleMode: PIXI.SCALE_MODES.LINEAR,
    crossorigin: '',
    crossOrigin: '',
    resourceOptions: {
      crossorigin: true,
      crossOrigin: true
    }
  })
  cat.alpha = 1
  cat.width = settings.width
  cat.height = settings.height
  cat.x = 0
  cat.y = 0
  cat.orderZ = 1
  return cat
}

export default function drawProduct(settings, CANVAS_RESIZE_FACTOR) {
  const baseTexture = new PIXI.Texture.from(settings.image)
  const heightTextureFactor = settings.canvasHeight / settings.height
  const texture = new PIXI.Texture(
    baseTexture,
    new PIXI.Rectangle(
      0,
      Math.floor(
        heightTextureFactor * (settings.maxHeight < settings.height ? settings.height - settings.maxHeight : 0)
      ),
      settings.canvasWidth,
      Math.floor(heightTextureFactor * Math.min(settings.maxHeight, settings.height))
    )
  )
  const cat = PIXI.Sprite.from(settings.image.width ? texture : baseTexture, {
    mipmap: false,
    scaleMode: PIXI.SCALE_MODES.LINEAR,
    crossorigin: '',
    crossOrigin: '',
    resourceOptions: {
      crossorigin: true,
      crossOrigin: true
    }
  })

  cat.texture.baseTexture.mipmap = false
  cat.alpha = 1
  cat.buttonMode = true

  cat.width = settings.width
  cat.height = Math.min(settings.height, settings.maxHeight)
  cat.crossorigin = true
  cat.interactive = settings.interactive
  cat.zIndex = settings.z
  cat.x = settings.x
  cat.oldX = settings.x
  cat.y = settings.y
  cat.tint = settings.tint
  cat.orderZ = settings.order

  // window.monitorEvents(cat)
  // console.log(cat)
  cat.on('touchstart', () => {
    cat.pressed = true
  })

  cat.on('touchmove', () => {
    cat.pressed = false
  })

  cat.on('mouseover', () => {
    if (settings.noHover) return
    if (settings.emulatedMobile) {
      return
    }
    // const extract = se ttings.renderer.plugins.extract
    // const pixels = extract.pixels(cat)
    // const context = canvas.getContext("2d")
    // const rgba = context.getImageData(event.data.global.x, event.data.global.y, 1, 1).data
    // console.log(pixels)
    // console.log(event.data.global.x)
    // console.log(event.data.global.y)
    // console.log(event.data.originalEvent.clientX)

    // if (!settings.scrolling) ticker.start()
    // cat.oldWidth = cat.width
    // cat.oldHeight = cat.height
    // cat.oldTint = cat.tint
    // cat.oldY = cat.y
    // cat.oldZIndex = cat.zIndex
    // cat.zIndex = 100
    // if (settings.fridge && settings.discrete && settings.last) cat.y = cat.y - 30
    // else {
    //   cat.y = CANVAS_RESIZE_FACTOR * settings.hoverY - cat.height * (settings.noGravitation ? 0 : 0.1)
    //   cat.width = cat.width * 1.1
    //   cat.height = cat.height * 1.1
    // }
    // cat.tint = FIRST_LAYER_COLOR

    if ('function' == typeof settings.onHover)
      settings.onHover({
        src: settings.image.src,
        x: cat.x / CANVAS_RESIZE_FACTOR,
        y: cat.y / CANVAS_RESIZE_FACTOR,
        width: cat.width / CANVAS_RESIZE_FACTOR,
        height: cat.height / CANVAS_RESIZE_FACTOR,
        marginTop:
          (settings.maxHeight < settings.height ? settings.height - settings.maxHeight : 0) / CANVAS_RESIZE_FACTOR
      })
  })

  cat.on('mouseout', () => {
    // if (!settings.scrolling) ticker.start()
    // cat.width = cat.oldWidth
    // cat.height = cat.oldHeight
    // cat.tint = cat.oldTint
    // cat.zIndex = cat.oldZIndex
    // cat.y = cat.oldY
    // if (!settings.scrolling)
    //   setTimeout(() => {
    //     ticker.stop()
    //   }, 20)
    if ('function' === typeof settings.onHover) settings.onHover(null)
  })

  cat.on('pointerup', event => {
    if (settings.noHover) return
    if (settings.emulatedMobile) {
      const coords =
        (settings.additionalX + event.data.global.x / CANVAS_RESIZE_FACTOR).toFixed(2) +
        ',' +
        (event.data.global.y / CANVAS_RESIZE_FACTOR).toFixed(2)
      settings.callback(coords)
      // setTimeout(() => {

      // }, 100)
    }
  })

  cat.on('mousedown', event => {
    if (settings.noHover) return
    if (settings.emulatedMobile) {
      const coords =
        (settings.additionalX + event.data.global.x / CANVAS_RESIZE_FACTOR).toFixed(2) +
        ',' +
        (event.data.global.y / CANVAS_RESIZE_FACTOR).toFixed(2)
      settings.callback(coords)
    }
  })

  cat.on('touchend', event => {
    if (cat.pressed) {
      if (settings.noHover) return
      const coords =
        (settings.additionalX + event.data.global.x / CANVAS_RESIZE_FACTOR).toFixed(2) +
        ',' +
        (event.data.global.y / CANVAS_RESIZE_FACTOR).toFixed(2)
      setTimeout(() => {
        settings.callback(coords)
      }, 100)
    }
    cat.pressed = false
  })

  cat.on('click', event => {
    if (settings.noHover) return
    const coords =
      (settings.additionalX + event.data.global.x / CANVAS_RESIZE_FACTOR).toFixed(0) +
      ',' +
      (event.data.global.y / CANVAS_RESIZE_FACTOR).toFixed(0)
    setTimeout(() => {
      settings.callback(coords)
    }, 100)
  })

  return cat
}
